import { render, staticRenderFns } from "./Well.vue?vue&type=template&id=b72fe614&scoped=true&"
import script from "./Well.vue?vue&type=script&lang=js&"
export * from "./Well.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72fe614",
  null
  
)

export default component.exports